import http, { handleApiResponse } from "@/services/http";
import PasswordChangeModel from "../models/PasswordChangeModel";
import ApiResponse from "@/models/ApiResponse";

export default class PasswordApi{
    static PostNewPassword(passwordChangeModel: PasswordChangeModel): Promise<string> {
        return http.post<ApiResponse<string>>(`users/change-password`,passwordChangeModel)
        .then(handleApiResponse);
    }
}